module.exports = __webpack_public_path__ + "img/css.f21c7ff1.svg";